import React from 'react';
import { Form as AntdForm } from 'antd';
import FormBase, { FormInstance, FormProps } from 'antd/lib/form';
import { isEmpty } from 'lodash';

const Form = (props: FormProps): any => {
  const { form, onValuesChange, ...rest } = props;

  const resetAllErrors = (formInstance: FormInstance) => {
    const fildsWithErrors = formInstance.getFieldsError().filter((item) => !isEmpty(item.errors));
    formInstance.setFields(fildsWithErrors.map((item) => ({ name: item.name, errors: [] })));
  };

  const handleValuesChange = (changedValues: any, values: any) => {
    if (typeof onValuesChange === 'function') {
      onValuesChange(changedValues, values);
    }
    if (form) {
      resetAllErrors(form);
    }
  };

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return (
    <AntdForm form={form} validateTrigger="onBlur" onValuesChange={handleValuesChange} {...rest} />
  );
};

const { Item, List, useForm, Provider } = AntdForm;

Form.Item = Item;
Form.List = List;
Form.useForm = useForm;
Form.Provider = Provider;

export default Form as typeof FormBase;
